export default __webpack_public_path__ + "static/media/platform_background_left.ad24729a.png";